import { Directive } from '@angular/core';
import { LayoutDirective as FlexLayoutLayoutDirective } from '@angular/flex-layout';

const inputs = [
  'flLayout',
  'flLayout.mobile',
  'flLayout.tablet',
  'flLayout.desktop-small',
  'flLayout.desktop-large',
  'flLayout.desktop-xlarge',
  'flLayout.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayout],
    [flLayout.mobile],
    [flLayout.tablet],
    [flLayout.desktop-small],
    [flLayout.desktop-large],
    [flLayout.desktop-xlarge],
    [flLayout.desktop-xxlarge],
  `,
  inputs,
})
export class LayoutDirective extends FlexLayoutLayoutDirective {
  protected inputs = inputs;
}
